import ReactGA from "react-ga4";
import { environment } from "config/environment";


export const GAHandler = (action, params) => {
  ReactGA.event(action, params);

  if (!environment.isProduction) {
    console.log({ action, params });
  }
};
